import styled from "styled-components";
import { Button, DropdownMenu, IconButton, Segmented } from "@axum/ax-design";
import { ScrollHint } from "../../Common/ScrollHint";
import { LAPTOP_MEDIA } from "../Filters/Filters.styles";

export const SectionTabs = styled(Segmented)`
  max-width: 100%;
  overflow-x: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

// Si las pestañas comparten renglón con el título, en tablet empujan el "…" a un renglón suelto.
export const PageHeader = styled.div`
  @media (max-width: 1023px) {
    .ax-page-header-main {
      display: contents;
    }

    ${ScrollHint} {
      order: 1;
      flex-basis: 100%;
    }

    ${SectionTabs} {
      flex: 1 1 auto;
    }

    .ax-page-header-actions {
      flex: 1 1 0%;
      justify-content: flex-end;
      min-width: 0;
    }
  }
`;

export const KpiRow = styled.section`
  && .ax-kpi-card-label {
    color: var(--ax-text-primary);
  }

  && .ax-kpi-card-value {
    font-size: var(--ax-font-size-metric);
    font-weight: var(--ax-fw-semibold);
  }

  &&:not(.is-loading) .o360-kpi-alert {
    color: var(--ax-danger-on-tint);
  }

  .o360-kpi-icon {
    display: inline-flex;
    flex: none;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    border-radius: var(--ax-radius-pill);
  }

  .o360-kpi-icon > .ax-icon {
    width: 14px;
    height: 14px;
  }

  .o360-kpi-icon.is-accent {
    background: var(--ax-accent-tint);
    color: var(--ax-accent-on-tint);
  }

  .o360-kpi-icon.is-danger {
    background: var(--ax-danger-tint);
    color: var(--ax-danger-on-tint);
  }

  .o360-kpi-icon.is-warning {
    background: var(--ax-warning-tint);
    color: var(--ax-warning-on-tint);
  }

  @media ${LAPTOP_MEDIA}, (max-width: 560px) {
    && .ax-kpi-card-value {
      font-size: var(--ax-font-size-title);
    }

    .o360-kpi-icon {
      width: 18px;
      height: 18px;
    }

    .o360-kpi-icon > .ax-icon {
      width: 12px;
      height: 12px;
    }
  }
`;

export const ElsewhereButton = styled(Button)`
  && {
    align-self: center;
    gap: 4px;
    height: 22px;
    padding: 0 var(--ax-space-2);
  }
`;

export const ViewMenuButton = styled(IconButton)`
  &.has-changes::after {
    content: "";
    position: absolute;
    top: 1px;
    right: 1px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: var(--ax-accent-500);
    box-shadow: 0 0 0 2px var(--ax-card-bg);
    pointer-events: none;
  }
`;

export const ViewOptionsMenu = styled(DropdownMenu)`
  && .o360-menu-warning {
    color: var(--ax-warning-on-tint);
  }
`;

export const ViewSettingsMenu = styled(DropdownMenu)`
  min-width: 260px;

  .o360-view-setting {
    justify-content: space-between;
    align-items: center;
  }

  .o360-view-setting-row {
    display: flex;
    gap: var(--ax-space-3);
    padding: var(--ax-space-2) var(--ax-space-3);
  }

  .o360-view-setting-row[aria-disabled="true"] {
    opacity: 0.45;
  }

  .o360-switch {
    position: relative;
    flex: none;
    width: 32px;
    height: 18px;
    border-radius: var(--ax-radius-round);
    background: var(--ax-form-switch-track);
    transition: background-color var(--ax-dur-hover) ease-out;
  }

  .o360-switch::after {
    content: "";
    position: absolute;
    top: 2px;
    left: 2px;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: var(--ax-on-accent);
    box-shadow: var(--ax-shadow-knob);
    transition: transform var(--ax-dur-enter) var(--ax-ease-spring);
  }

  [aria-checked="true"] > .o360-switch {
    background: var(--ax-accent-500);
  }

  [aria-checked="true"] > .o360-switch::after {
    transform: translateX(14px);
  }

  .o360-view-reset {
    justify-content: center;
  }
`;
